<template>
    <div class="grid sm:grid-cols-2" data-cy="container_profile_address">
        <FormAddressDropdown
                v-model:inputValue="addressModel"
                :errorInfo="errorInfo[0]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.profile"
                data-cy="component_profile_address_dropdown"
        ></FormAddressDropdown>
    </div>
</template>
<script>
import { FormHelper } from "@/helper/FormHelper.js";
import FormAddressDropdown from "@/components/Form/FormAddressDropdown.vue";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js";

export default {
    name: "FormAddressProfile",
    mixins: [LocaleMixin],
    components: {
        FormAddressDropdown,
    },
    data: function() {
        return {
            isSubmitted: false,
            errorInfo: FormHelper.genErrorInfo(1),

            addressModel: new AddressModel(),
        };
    },
}
</script>
<style lang="scss" scoped>
</style>
